/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePaymentSchedulingDto } from '../../models/update-payment-scheduling-dto';

export interface PaymentSchedulingControllerUpdatePaymentScheduling$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Visit identifier
 */
  visitId: string;
      body: UpdatePaymentSchedulingDto
}

export function paymentSchedulingControllerUpdatePaymentScheduling(http: HttpClient, rootUrl: string, params: PaymentSchedulingControllerUpdatePaymentScheduling$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, paymentSchedulingControllerUpdatePaymentScheduling.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('visitId', params.visitId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

paymentSchedulingControllerUpdatePaymentScheduling.PATH = '/keus-payments/payment-scheduling/{tenant}/{visitId}';
